import { css, SerializedStyles } from '@emotion/core';

const styles = {
  titleText: (): SerializedStyles => css`
    text-align: center;
  `,
};

export default styles;
